module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "calibre1",
    attrs: {
      "alt": "image",
      "src": "images/frontline-logo-small.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter1"
  }, [_vm._v("This edition of "), _c('em', {
    staticClass: "calibre10"
  }, [_vm._v("On the Road with Wellington")]), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("First published 1999 by"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("Greenhill Books"), _c('br'), _vm._v("published in this format in 2015 by"), _c('br'), _vm._v("Frontline Books"), _c('br'), _vm._v("an imprint of"), _c('br'), _vm._v("Pen & Sword Books Ltd"), _c('br'), _vm._v("47 Church Street, Barnsley, S70 2AS"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.frontline-books.com",
      "target": "_blank"
    }
  }, [_vm._v("www.frontline-books.com")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter1"
  }, [_vm._v("Translation © University of Edinburgh, 1924"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("Introduction © Bernard Cornwell, 1999")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("a retrieval system or transmitted in any form or by any means, electronic,"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("mechanical or otherwise without the written permission of the Publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter1"
  }, [_c('em', {
    staticClass: "calibre10"
  }, [_vm._v("British Library Cataloguing in Publication Data")]), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("Schaumann, A. L. F."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("On the road with Wellington: the diary of a war commissary. -"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("(Napoleonic Library; 34)"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("1. Peninsular War, 1807–1814 - Personal narratives, German"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("I. Title"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("940.2’7")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter1"
  }, [_vm._v("ISBN 1-85367-353-6")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter1"
  }, [_c('em', {
    staticClass: "calibre10"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("Schaumann, August Ludolf Friedrich, 1778–1840."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("On the road with Wellington: the diary of a war commissary/by"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("A. L. F. Schaumann; introduction by Bernard Cornwell. p.      cm."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("ISBN 1-85367-353-6"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("1. Schaumann, August Ludolf Friedrich, 1778-1840—Diaries."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("2. Peninsular War, 1807-1814—Personal narratives, German. 3. Great"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("Britain, Army. King’s German Legion—Diaries. I. Title.")]), _vm._v(" "), _c('table', {
    staticClass: "paracenter2",
    attrs: {
      "width": "80%"
    }
  }, [_c('colgroup', [_c('col', {
    staticClass: "calibre11"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre11"
  })]), _c('tbody', {
    staticClass: "calibre12"
  }, [_c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("DC232.S43 1999")]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("940. 2’7—dc21")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_vm._v("98-49193")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }), _c('td', {
    staticClass: "calibre15"
  }, [_vm._v("CIP")])])])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter1"
  }, [_vm._v("Publishing History"), _c('br', {
    staticClass: "calibre9"
  }), _c('em', {
    staticClass: "calibre10"
  }, [_vm._v("On the Road with Wellington: The Diary of a War Commissary in the"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("Peninsular Campaigns")]), _vm._v(" was translated and edited from the German by"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("Anthony M. Ludovici and first published in 1924 (William Heinemann Ltd.,"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("London). The text is now reproduced complete and unabridged, with the"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("addition of a new Introduction by Bernard Cornwell. The original watercolours"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("have been omitted for reasons of reproduction quality.")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter1"
  }, [_vm._v("Printed and bound in Great Britain by"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("Creative Print and Design (Wales), Ebbw Vale.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54396cd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0003.vue
// module id = 66
// module chunks = 0